var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mdc-list-group"},[(_vm.subheader.length > 0)?_c('h3',{staticClass:"mdc-list-group__subheader"},[_vm._v(" "+_vm._s(_vm.subheader)+" ")]):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }